import { ContainerStyle } from "./container.styled"

export const Container = ({ children }) => {
  return <ContainerStyle>{children}</ContainerStyle>
}